export default "__VITE_ASSET__DIBKL0Q5__"